export function filterOrders(rows, { tab, search, category }) {
  const q = search.trim().toLowerCase();
  let list = rows;

  if (tab && tab !== "all") {
    const map = {
      new: "new_order",
      processing: "processing",
      ready_pickup: "ready_pickup",
      out_delivery: "out_delivery",
      delivered: "delivered",
      failed_delivery: "failed_delivery",
      cancelled: "cancelled",
    };
    const want = map[tab];
    if (want) list = list.filter((r) => r.status === want);
  }

  if (category && category !== "") {
    list = list.filter((r) => r.category === category);
  }

  if (q) {
    list = list.filter(
      (r) =>
        r.orderId.toLowerCase().includes(q) ||
        r.customerName.toLowerCase().includes(q) ||
        r.productName.toLowerCase().includes(q) ||
        r.sku.toLowerCase().includes(q)
    );
  }

  return list;
}

export function paginateSlice(items, page, pageSize) {
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function totalPagesFor(itemsLength, pageSize) {
  return Math.max(1, Math.ceil(itemsLength / pageSize));
}

export function countOrdersByTab(rows) {
  return {
    new: rows.filter((r) => r.status === "new_order").length,
    processing: rows.filter((r) => r.status === "processing").length,
  };
}

/** Summary strip (New / Processing / Out for Delivery / Delivered). */
export function computeStatCounts(rows) {
  return {
    new: rows.filter((r) => r.status === "new_order").length,
    processing: rows.filter((r) => r.status === "processing").length,
    out_delivery: rows.filter((r) => r.status === "out_delivery").length,
    delivered: rows.filter((r) => r.status === "delivered").length,
  };
}
